import $ from 'jquery';

const initCardSubscription = function () {
    /*
        If a card subscription button is present on the DOM, we initialise and bind the click
        to that button in order to be redirected to the subscription pages
     */
    $(document).on('click', '.dcw_cta--red--rounded', function (event) {
        event.stopPropagation();
        var href = $(this).children().attr('href');
        var cardReference = $('.dcw_cta--red--rounded').children().data("card-reference");
        if (cardReference !== null && cardReference !== "") {
            href += cardReference;
        }
        $(this).children().attr("href", href);
    });
};

export {initCardSubscription};


// WEBPACK FOOTER //
// ./src/js/cms/pri/initCardSubscription.js